import { Directive, Renderer2, ElementRef } from '@angular/core';

@Directive({
  selector: '[autoMargin]'
})
export class AutoMarginDirective {

  interval: any

  constructor(
    private elementRef: ElementRef,
    private renderer  : Renderer2
  ) { }

  ngOnInit(): void {
    this.interval = setInterval( () => this.checkSize(), 1000 )
  }

  checkSize(){

    const div_height = this.elementRef.nativeElement.offsetHeight;
    const win_height = window.innerHeight;
  
    if (div_height < win_height) 
    {
      this.renderer.removeClass(
        this.elementRef.nativeElement,
        'my-4'
      );
    }else
    {
      this.renderer.addClass(
        this.elementRef.nativeElement,
        'my-4'
      );
    }

  }

  ngOnDestroy(): void {    
    clearInterval ( this.interval )
  }


}
